<template>
    <div v-if="open" id="g2-popover" @click="handleOutsideClick">
        <span id="g2-popover-content" :style="style" @click.stop>
            <slot :content="content">
                G2 Popover Content
            </slot>
        </span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
            style: {
                top: '0px',
                left: '0px',
            },
            content: null
        };
    },
    methods: {
        handleOutsideClick() {
            this.close()
        },
        show({ top, left }, data) {
            this.content = data
            this.open = true
            this.style = { 
                top: top ? `${top + 10}px` : '20px',
                left: left ? `${left - 20}px` : '20px'
            }
        },
        close() {
            this.open = false
            this.content = null
        }
    }
}
</script>

<style scoped>
#g2-popover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1030;
}

#g2-popover-content {
    position: relative;
    display: inline-block;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    text-align: center;
    padding: 0.2rem;
}

#g2-popover-content::before {
    content: "";
    position: absolute;
    display: inline-block;
    top: -5px;
    left: 10px;
    width: 10px;
    height: 10px;
    transform: rotateZ(45deg);
    background-color: white;
}
</style>